import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer } from "@wordpress/element";
import { INIT_APP_STATE } from "../constants";
import { reducer } from "../reducers/app-reducer";
const initialState = {
    siteURL: "",
    publicUserPageId: "",
    is_customFields: false,
    timezone: "",
    isUserAllowedToDelete: false,
};
const AppContext = createContext({
    state: initialState,
    appDispatch: () => { },
});
const AppContextProvider = ({ children }) => {
    const [state, appDispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        const siteURL = window.wpqt.siteURL;
        const publicUserPageId = window.wpqt.publicUserPageId;
        const timezone = window.wpqt.timezone;
        const isUserAllowedToDelete = window.wpqt.isUserAllowedToDelete === "1";
        appDispatch({
            type: INIT_APP_STATE,
            payload: {
                siteURL,
                publicUserPageId,
                timezone,
                isUserAllowedToDelete,
            },
        });
    }, []);
    return (_jsx(AppContext.Provider, { value: { state, appDispatch }, children: children }));
};
export { AppContext, AppContextProvider };
